<template>
    <Home fit="cover">
        <template #picture>
            <!-- background -->
            <source media="(orientation: portrait)" srcset="../assets/img/Titelbild_blau.jpg">
            <source media="(orientation: landscape)" srcset="../assets/img/Titelbild_blau.jpg">
        </template>
        <template #headline>Wie der Klimawandel die Alpen verändert</template>
        <template #text>
        </template>
        <template #update>
            18.07.2025<br>
            Update: 23.06.2026
            <br>
        </template>
    </Home>
</template>

<script>
    export default {
        name: 'home',
        babylonState: {
            camera:{
                position:  [.92,.95,98],//[.5 * Math.PI, .5 * Math.PI, 10], // alpha, beta, radius   //VÖ: .95,1,130
                target: [-2, 8, -5.4], // Wohin die Kamera blickt                                 //Vö -0.5, 8.5, -6
                animationSpeed: 250, // Geschwindigkeit der Kamerabewegung
                //betaLimits: [0.1, Math.PI / 2],
                useAutoRotationBehavior: true,
                idleRotationSpeed: .01,  //0.01
            },
        },
        babylonReady: function ()
        {

        },
        // methods: {
        //     next: function () {
        //         this.$tracking.navigationClick('Start');
        //         this.$eventBus.$emit('nextPage');
        //     }
        // },
    }
</script>

<style lang="scss">

    .home {

        // change default opacity: 0.35
        .home__background {

            opacity: 1.0;
        }
        // change default object-position: unset (50% 50%)  / Für Portrait ist nur der x-Wert relevant, für Landscape nur der y-Wert. / Einheit entweder in "%" oder "px"
        .home__background img.o-fit {

            //object-position: 50% 0%;
            //
            //@media (orientation: landscape) {
            //
            //    object-position: 0% 50%;
            //}
        }
    }

</style>